/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: xuRui.
* Date: 2019/12/30  15:30.
*/
<template>
  <div class="feedbackBox">
    <v-title
      title="反馈药店信息"
      :isShowBack="true"
      :isDefaultBack="false"
      @backHandle="goBack()"
    ></v-title>
    <div class="top-box">
      <div class="top-title">{{ detailData.clientName }}</div>
      <div class="address-message">{{ detailData.clientAddress }}</div>
      <div class="phone-message">
        <span>{{ detailData.phone === "" ? "暂无" : detailData.phone }}</span
        ><span>{{ $store.state.clientType[detailData.thirdType] }} </span>
      </div>
      <div class="status-message">
        <span>经营状态：{{ detailData.businessStatus }}</span
        ><span>税收状态：{{ detailData.taxStatus }}</span>
      </div>
    </div>
    <div class="line-middle"></div>
    <ul class="choice-list">
      <li
        v-for="(item, index) in resionList"
        :key="index"
        @click="goDetail(item, index)"
      >
        <img :src="item.img" /> <span>{{ item.title }}</span>
        <img class="checkIcon" v-show="checkIndex === index" :src="rightIcon" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      columns: [
        {
          title: '主数据id',
          dataIndex: 'number'
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '省市区乡村',
          dataIndex: 'area',
          scopedSlots: { customRender: 'area' }
        },
        {
          title: '地址',
          dataIndex: 'address',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'unifiedSocialCreditCode',
          scopedSlots: { customRender: 'unifiedSocialCreditCode' }
        },
        {
          title: '主要推荐原因',
          dataIndex: 'matchRelation'
        }
      ],
      data: [
        {
          number: 1
        }
      ],
      loading: false,
      checkIndex: '',
      keyword: '',
      detailData: {},
      rightIcon: require('@/assets/feedback/checked.png'),
      resionList: [
        {
          title: '药店不存在或者已闭店',
          img: require('@/assets/feedback/inexistence.png')
        },
        {
          title: '电话、地址位置错误',
          img: require('@/assets/feedback/Address-elephone.png')
        },
        {
          title: '药店属性变更',
          img: require('@/assets/feedback/property.png')
        }
      ]
    }
  },
  computed: {},
  created () {
    this.detailData = JSON.parse(this.$route.query.data)
    console.log('.....传来的值.......')
    console.log(this.detailData)
  },
  activated () {
    if (this.$route.meta.isUseCache) {
      this.detailData = JSON.parse(this.$route.query.data)
      this.checkIndex = ''
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    goDetail (item, index) {
      this.pushUserLog('进入反馈')
      this.checkIndex = index
      switch (index) {
        case 0:
          this.$router.push({
            name: 'closeStore',
            query: { data: JSON.stringify(this.detailData) }
          })
          break
        case 1:
          this.$router.push({
            name: 'addDetail',
            query: {
              data: JSON.stringify(this.detailData),
              frash: true,
              first: true
            }
          })
          break
        case 2:
          this.$router.push({
            name: 'changeQuality',
            query: { data: JSON.stringify(this.detailData) }
          })
          break
        default:
          break
      }
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    },
    pushUserLog (text) {
      // 上报操作日志
      this.$store.dispatch('PushUserLog', {
        menu: '终端地图',
        page: '终端地图',
        operation: text
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (
      to.name === 'closeStore' ||
      to.name === 'addDetail' ||
      to.name === 'changeQuality'
    ) {
      from.meta.isUseCache = false
    }
    next()
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';

.feedbackBox {
  height: 100%;

  .top-box {
    background: #fff;
    padding: 20px;
    padding-top: 80px;

    .top-title {
      font-size: 30px;
      margin: 10px 0;
      line-height: 50px;
      font-weight: 600;
    }

    .address-message {
      margin: 20px 0;
      font-size: 26px;
      color: #999;
    }

    .phone-message {
      margin: 20px 0;
      font-size: 26px;
      display: flex;
      color: #999;

      span {
        flex: 1;
      }
    }

    .status-message {
      margin: 20px 0;
      font-size: 26px;
      color: #999;
      display: flex;

      span {
        flex: 1;
      }
    }
  }

  .line-middle {
    height: 20px;
    background: #eee;
  }

  .choice-list {
    li {
      border-bottom: 1px solid #efefef;
      height: 90px;
      line-height: 90px;
      padding: 0 32px;
      font-size: 30px;
      color: #333;
      display: flex;
      position: relative;
      align-items: center;

      img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }

      .checkIcon {
        width: 40px;
        height: 40px;
        margin-left: 20px;
        position: absolute;
        right: 20px;
      }
    }
  }
}
</style>
